export function maskFormat(m, t) {
  if (t && t.target) {
    var cursor = t.target.selectionStart;
    var texto = t.target.value;
    texto = texto.replace(/\D/g, '');
    var l = texto.length;
    var lm = m.length;
    var id;
    if (window.event) {
      id = t.keyCode;
    } else if (t.which) {
      id = t.which;
    }
    var cursorfixo = false;
    var livre = false;

    if (cursor < l) cursorfixo = true;
    if (id === 16 || id === 19 || (id >= 33 && id <= 40)) livre = true;

    if (!livre) {
      if (id !== 8) {
        t.target.value = '';
        var j = 0;
        for (var i = 0; i < lm; i++) {
          if (m.substr(i, 1) === '#') {
            t.target.value += texto.substr(j, 1);
            j++;
          } else if (m.substr(i, 1) !== '#') {
            t.target.value += m.substr(i, 1);
          }
          if (id !== 8 && !cursorfixo) cursor++;
          if (j === l + 1) break;
        }
      }
    }
    if (cursorfixo && !livre) cursor--;
    t.target.setSelectionRange(cursor, cursor);
  }
}
